import React, { createContext, useContext, useMemo } from "react";
import { useSelector } from "react-redux";
import { RootState } from "@src/reducers/store";
import { i18n } from "@src/i18n/i18n";
import { Language } from "@src/reducers/your-reducer";

const LanguageContext = createContext<{
  language: Language;
  i18n: (key: string) => string;
}>({
  language: "en",
  i18n: (key: string) => i18n(key, "en"),
});

interface LanguageProviderPropTypes {
  children: React.ReactNode;
}

export const LanguageProvider = ({ children }: LanguageProviderPropTypes) => {
  const language = useSelector((state: RootState) => state.yourSlice.language);

  const value = useMemo(
    () => ({
      language,
      i18n: (key: string) => i18n(key, language),
    }),
    [language],
  );

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useI18N = () => {
  const { i18n: translate } = useContext(LanguageContext);
  return translate;
};

export const useLanguage = () => {
  const { language } = useContext(LanguageContext);
  return language;
};
